// --------------------New code 2---------------------
import React, { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "../firebase";

const TeacherTimetable = () => {
  const [formData, setFormData] = useState({ teacher: "" });
  const [teachers, setTeachers] = useState([]);
  const [timetableData, setTimetableData] = useState([]);
  const [numberOfPeriods, setNumberOfPeriods] = useState(0);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const udiseNumber = localStorage.getItem("udiseNumber");
const [schoolData, setSchoolData] = useState('');

  // Fetch the number of periods from Firebase
  useEffect(() => {
    const periodsRef = ref(db, `schoolRegister/${udiseNumber}/periods/`);
    onValue(periodsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setNumberOfPeriods(data.numberOfPeriods || 0);

        const periodsArray = Array.from(
          { length: data.numberOfPeriods || 0 },
          (_, i) => `${i + 1}`
        );
        setAvailablePeriods(periodsArray);
      }
      else{
        const periodsArray = Array.from(
          { length: 7 || 0 },
          (_, i) => `${i + 1}`
        );
        setAvailablePeriods(periodsArray);
      }
    });
  }, []);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };

    const fetchSchoolData = async () => {
      if (udiseNumber) {
        try {
          const db = await openIndexedDB();
          const transaction = db.transaction(['schoolData'], 'readonly');
          const objectStore = transaction.objectStore('schoolData');
          const request = objectStore.get(udiseNumber);
  
          request.onsuccess = (event) => {
            const data = event.target.result;
            if (data) {
              setSchoolData(data);
            }
          };
  
          request.onerror = (event) => {
            console.error("Error fetching school data:", event.target.error);
          };
        } catch (error) {
          console.error('Error fetching school data:', error);
        }
      }
    };
        useEffect(() => {
          fetchSchoolData ();
      }, [udiseNumber]);
    
  // Fetch all unique teachers
  useEffect(() => {
    const fetchTeacherData = () => {
      const teacherRef = ref(db, `AttendanceData/${udiseNumber}/AttData`);

      onValue(
        teacherRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const teachersData = snapshot.val();
            const teacherList = [];

            Object.keys(teachersData).forEach((mobileNumber) => {
              const teacher = teachersData[mobileNumber];
              if (teacher?.Name) {
                teacherList.push(teacher.Name);
              }
            });

            setTeachers(teacherList);
            console.log("Fetched teachers:", teacherList); // Debugging
          } else {
            console.log("No teacher data found");
          }
        },
        (error) => {
          console.error("Firebase error:", error);
        }
      );
    };

    if (udiseNumber) fetchTeacherData();
  }, [udiseNumber]);


  // Fetch timetable data
  useEffect(() => {
    if (formData.teacher) {
      const timetableRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign`);
      onValue(timetableRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = [];
          Object.keys(data).forEach((cls) => {
            Object.keys(data[cls]).forEach((div) => {
              if (data[cls][div][formData.teacher]) {
                Object.keys(data[cls][div][formData.teacher]).forEach((day) => {
                  const periods = data[cls][div][formData.teacher][day];
                  Object.keys(periods).forEach((periodName) => {
                    formattedData.push({
                      day,
                      period: periodName,
                      periodName,
                      subject: periods[periodName].subject,
                      startTime: periods[periodName].startTime,
                      endTime: periods[periodName].endTime,
                      class: cls,
                      division: div,
                    });
                  });
                });
              }
            });
          });
          setTimetableData(formattedData);
        } else {
          setTimetableData([]);
        }
      });
    } else {
      setTimetableData([]);
    }
  }, [formData.teacher]);

  const handleTeacherChange = (e) => {
    setFormData((prev) => ({ ...prev, teacher: e.target.value }));
  };

  // Group timetable by day for rendering
  const groupedTimetable = days.reduce((acc, day) => {
    acc[day] = timetableData.filter((item) => item.day === day);
    return acc;
  }, {});

  return (
    <div className="main-content-of-page">
      <div className="row justify-content-center">
        <div className="col-md-4 mb-3">
          <h1
            style={{ textAlign: "center", margin: "5px 0", fontFamily: "poppins" }}
          >
            Teacher Timetable
          </h1>

          <div className="card no-print">
            <div className="card-body no-print">
              <label htmlFor="teacherSelect" className="form-label no-print">
                Select Teacher
              </label>
              <select
                className="form-select no-print"
                id="teacherSelect"
                value={formData.teacher}
                onChange={handleTeacherChange}
              >
                <option value="">Select Teacher</option>
                {teachers.map((teacher) => (
                  <option key={teacher} value={teacher}>
                    {teacher}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4" style={{margin:'auto 5%'}}>
       <h2 style={{ textAlign: "center", fontSize: "22px" }}>{schoolData.schoolName}</h2>
          <h5 style={{ textAlign: "center", fontSize: "14px" }}>Tal.:- {schoolData.taluka}, Dist.:- {schoolData.jilha}</h5>
          <h5 style={{ textAlign: "center", marginBottom: "10px", fontSize: "16px" }}>
            {formData.teacher}
          </h5>

        <table
          className="table table-striped table-hover text-center"
          style={{
            overflowX: "auto",
            width: "100%", 
          }}
        >
          <thead className="table-primary">
            <tr>
              <th style={{border:'1px solid gray', width: `${100 / (availablePeriods.length + 1)}%` }}>Day</th>
              {availablePeriods.map((period) => (
                <th key={`period-${period}`} style={{ border:'1px solid gray', width: `${100 / (availablePeriods.length + 1)}%` }}>
                  Period {period}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {days.map((day) => (
              <tr key={day}>
                <td style={{border:'1px solid gray'}} className="align-middle">{day}</td>
                {availablePeriods.map((period) => {
                  const entry = groupedTimetable[day]?.find(
                    (item) => item.period === `${period}`
                  );
                  return (
                    <td style={{border:'1px solid gray'}}  key={`day-${day}-period-${period}`} className="align-middle">
                      {entry ? (
                        <>
                          <p><strong>Subject:</strong> {entry.subject}</p>
                          <p><strong>Class:</strong> {entry.class}</p>
                          <p><strong>Division:</strong> {entry.division}</p>
                          <p><strong>Time:</strong> {entry.startTime} - {entry.endTime}</p>
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>

        <div>
          <button className="no-print btn btn-primary mb-4" onClick={() => window.print()}>
            Print Timetable
          </button>
        </div>
      </div>

      <style>
        {`
        @media print {
          body {
            -webkit-print-color-adjust: exact;
          }
          
          .no-print {
            display: none !important;
          }

          table {
            width: 100%;
            table-layout: auto;
            border-collapse: collapse;
          }

          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: center;
            font-size: 12px;
          }

          thead {
            background-color: #8A1538;
            color: white;
          }

          tr {
            page-break-inside: avoid;
          }

          h2 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
        `}
      </style>
    </div>

  );
};

export default TeacherTimetable;